var _path, _path2, _path3, _path4, _ellipse, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 16.5C32.3333 25.2445 25.2445 32.3333 16.5 32.3333C7.75549 32.3333 0.666667 25.2445 0.666667 16.5C0.666667 7.75549 7.75549 0.666667 16.5 0.666667C25.2445 0.666667 32.3333 7.75549 32.3333 16.5Z",
    fill: "#1822B3",
    stroke: "#1822B3",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1465 17.2597C22.1418 17.2583 22.1371 17.2569 22.1323 17.2556C22.0445 17.2307 21.9555 17.2914 21.9336 17.391C21.9117 17.4905 21.9652 17.5914 22.0531 17.6161L22.0615 17.6186C22.0757 17.6229 22.09 17.625 22.1041 17.625C22.1765 17.625 22.2427 17.5703 22.2624 17.4873C22.2858 17.3882 22.234 17.2863 22.1465 17.2597Z",
    fill: "#1822B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4141 10.5097C18.4094 10.5083 18.4047 10.5069 18.3999 10.5056C18.312 10.4807 18.2231 10.5414 18.2012 10.641C18.1793 10.7405 18.2328 10.8414 18.3207 10.8661L18.3291 10.8686C18.3433 10.8729 18.3576 10.875 18.3717 10.875C18.444 10.875 18.5103 10.8203 18.5299 10.7373C18.5534 10.6382 18.5015 10.5363 18.4141 10.5097Z",
    fill: "#1822B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4258 23.7594L13.607 11.8928L20.5713 19.3928L8.8898 24.2323C8.59281 24.3553 8.29717 24.054 8.4258 23.7594Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.214286
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.2313,
    cy: 15.5424,
    rx: 1.25,
    ry: 5.21806,
    transform: "rotate(-44.2797 17.2313 15.5424)",
    fill: "#1822B3",
    stroke: "#FAFAFC",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7141,
    cy: 17,
    r: 0.107143,
    fill: "#FAFAFC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.607,
    cy: 14.0357,
    r: 0.535714,
    fill: "#FAFAFC",
    stroke: "#FAFAFC",
    strokeWidth: 0.214286,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.107,
    cy: 7.24995,
    r: 0.535714,
    fill: "white",
    stroke: "#FAFAFC",
    strokeWidth: 0.214286,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3926,
    cy: 8.82136,
    r: 0.535714,
    fill: "white",
    stroke: "#FAFAFC",
    strokeWidth: 0.214286,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5181,
    cy: 17.375,
    r: 0.25,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.203571,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5181,
    cy: 12.375,
    r: 0.25,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.203571,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/EventIcon.e17c6625b4efa4297a49ded0cf60dd4d.svg";
export { ForwardRef as ReactComponent };